import { App } from 'vue'
import { vfmPlugin, VfmOptions, VueFinalModalProperty } from 'vue-final-modal'

export const setupVfm = (app: App): void => {
  const options: VfmOptions = {
    key: '$vfm',
    componentName: 'VueFinalModal',
    dynamicContainerName: 'ModalsContainer'
  }
  app.use(vfmPlugin(options))
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    readonly $vfm: VueFinalModalProperty
  }
}
